import { useTranslation } from 'react-i18next';
import PageHero from '../../ui/PageHero/PageHero';
import PillLink from '../../ui/PillLink/PillLink';
import { CONTACT_PATH, mailtoHref } from '../../../data/navigation';
import { siteStat, type SiteStatId } from '../../../data/siteStats';
import { formatInteger } from '../../../i18n/formatNumber';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './ServicesHero.module.css';

const PROOF_STATS: SiteStatId[] = ['users', 'storeApps', 'websites'];

export default function ServicesHero() {
    const { t } = useTranslation();
    const { language, localizedPath } = useLanguage();
    const draftHref = mailtoHref(t('contactPage.offer.mailSubject'), t('contactPage.offer.mailBody'));

    return (
        <PageHero title={t('servicesPage.title')} lead={t('servicesPage.lead')}>
            <div className={styles.actions}>
                <PillLink href={localizedPath(CONTACT_PATH)} size="large" icon="arrowRight">{t('servicesPage.primaryAction')}</PillLink>
                <PillLink href={draftHref} variant="glass" size="large" icon="mail">{t('servicesPage.secondaryAction')}</PillLink>
            </div>
            <dl className={styles.proof}>
                {PROOF_STATS.map((id) => {
                    const stat = siteStat(id);
                    return (
                        <div key={id} className={styles.stat}>
                            <dt className={styles.label}>{t(`home.numbers.labels.${id}`)}</dt>
                            <dd className={styles.value}>{`${formatInteger(stat.value, language)}${stat.suffix ?? ''}`}</dd>
                        </div>
                    );
                })}
            </dl>
        </PageHero>
    );
}
